const url = '/destinations';
const Provider = 'Destinations';
const dbModel = 'Destinations';

export { url, Provider, dbModel };
